import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import truncateChars from 'rebook/apps/utils/text/truncateChars';
import Article from 'rebook/apps/base/components/Article';
import ArticleEmpty from 'rebook/apps/base/components/ArticleEmpty';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as FaqQuestionActions from 'rebook/apps/faq/actions/FaqQuestionActions';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';

import styles from './style.scss';


class FaqQuestionView extends React.Component {
  static fetchInitialDataForServer(match, store) {
    return store.dispatch(FaqQuestionActions.fetchInitialData(match));
  }

  componentDidMount() {
    const { match, location } = this.props;
    this.props.FaqQuestionActions.fetchInitialData(match, location);
  }

  componentWillUnmount() {
    this.props.SeoActions.resetData();
    this.props.FaqQuestionActions.resetData();
  }

  render() {
    const { content, title, questionSlug, sectionSlug } = this.props.faqQuestion;
    return (
      <div className={classNames('backgroundContainer', 'themeGrey')}>
        {(title && questionSlug) && (
          <div className="section">
            <BreadCrumbs links={[
              { text: 'Помощь', url: '/help/' },
              { text: truncateChars(title, 60), url: `/help/${sectionSlug}/${questionSlug}` },
            ]} />
          </div>
        )}
        <div className="col-md-6">
          <div className={styles.sectionHeader}>
            <h1 className="jest-help-question-title">{title}</h1>
          </div>
          <div className={styles.billetContainer}>
            {content
              ? (
                <Article
                  htmlContent={content}
                  extraClassName="jest-help-question-content" />
              )
              : <ArticleEmpty />
            }
          </div>
        </div>
      </div>
    );
  }
}

FaqQuestionView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      questionSlug: PropTypes.string.isRequired,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    faqQuestion: state.faqQuestion,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SeoActions: bindActionCreators(SeoActions, dispatch),
    FaqQuestionActions: bindActionCreators(FaqQuestionActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FaqQuestionView);
